/**
 * @module utils/time-since
 */
import format from "date-fns/format";
import diffInSeconds from "date-fns/difference_in_seconds";
import round from "lodash/round";

const ONE_MINUTE = 60;
const ONE_HOUR = 3600;
const ONE_DAY = 86400;
const THREE_DAYS = 259200;


/**
 * @method humanTime
 * @param {Number} left
 * @param {Number} right
 * @returns {String}
 */
export function humanTime(left, right) {
  let amount = Math.abs(diffInSeconds(left, right));

  if (amount < ONE_MINUTE) {
    return `${amount} second${amount > 1 ? "s" : ""} ago`;
  }
  if (amount < ONE_HOUR) {
    amount = round(amount / ONE_MINUTE);
    return `${amount} minute${amount > 1 ? "s" : ""} ago`;
  }
  if (amount >= ONE_HOUR && amount < ONE_DAY) {
    amount = round(amount / ONE_HOUR);
    return `${amount} hour${amount > 1 ? "s" : ""} ago`;
  }
  if (amount >= ONE_DAY && amount < THREE_DAYS) {
    amount = round(amount / ONE_DAY);
    return `${amount} day${amount > 1 ? "s" : ""} ago`;
  }

  return format(left, "MMMM D, YYYY");
}

/**
 * @method since
 * @description expects a seconds-based unix timestamp as input.
 *  conversion to milliseconds is necessary to make date-fns calculations work correctly.
 * @param {Number} unixTimeLeft - unix timestamp in seconds
 * @param {Number} [unixTimeRight] - unix timestamp in seconds, or current unix timestamp
 * @returns {String}
 */
export default function since(unixTimeLeft, unixTimeRight) {
  const left = unixTimeLeft * 1000;
  const right = unixTimeRight ? unixTimeRight * 1000 : parseInt(format(new Date(), "x"), 10);
  return humanTime(left, right);
}
